export default "__VITE_ASSET__D09SkJQ8__"